// AUTO-GENERATED by web/admin/scripts/gen-perms.mjs — do NOT edit by hand.
// Source: backend/app/core/permissions.py
// Regenerate: `pnpm gen:perms` (auto-runs on `pnpm build` via prebuild).
//
// The list below mirrors PERMISSIONS as of the last codegen run. The
// runtime catalog is also exposed at GET /admin/roles/permissions —
// production code can read either; this const exists for IntelliSense
// and for the AppShell nav-filter declarations.

export type Permission = string
export const WILDCARD: Permission = '*'

export const PERM = {
  photoshoots_read: 'photoshoots.read',
  photoshoots_write: 'photoshoots.write',
  featured_write: 'featured.write',
  models_read: 'models.read',
  models_write: 'models.write',
  plans_read: 'plans.read',
  plans_write: 'plans.write',
  users_read: 'users.read',
  users_write: 'users.write',
  users_role: 'users.role',
  roles_read: 'roles.read',
  roles_write: 'roles.write',
  generations_read: 'generations.read',
  generations_write: 'generations.write',
  audit_read: 'audit.read',
  settings_write: 'settings.write',
  fal_models_read: 'fal_models.read',
  fal_models_write: 'fal_models.write',
  cron_read: 'cron.read',
  cron_write: 'cron.write',
  media_write: 'media.write',
  login_images_read: 'login_images.read',
  login_images_write: 'login_images.write',
  paywall_images_read: 'paywall_images.read',
  paywall_images_write: 'paywall_images.write',
  support_read: 'support.read',
  support_write: 'support.write',
  app_review_read: 'app_review.read',
  app_review_write: 'app_review.write',
} as const

export const PERMISSIONS_LIST: readonly Permission[] = [
  'photoshoots.read',
  'photoshoots.write',
  'featured.write',
  'models.read',
  'models.write',
  'plans.read',
  'plans.write',
  'users.read',
  'users.write',
  'users.role',
  'roles.read',
  'roles.write',
  'generations.read',
  'generations.write',
  'audit.read',
  'settings.write',
  'fal_models.read',
  'fal_models.write',
  'cron.read',
  'cron.write',
  'media.write',
  'login_images.read',
  'login_images.write',
  'paywall_images.read',
  'paywall_images.write',
  'support.read',
  'support.write',
  'app_review.read',
  'app_review.write',
] as const
